module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "warp": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg10": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-5 pa-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "formValidate"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('postingcreate.Title'),
      "rules": _vm.titleRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formValidate.postingTitle),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "postingTitle", $$v)
      },
      expression: "formValidate.postingTitle"
    }
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticClass: "d-none upload-image",
    attrs: {
      "name": "upfile",
      "format": ['jpg', 'jpeg', 'png', 'gif'],
      "max-size": 4096,
      "headers": _vm.headers,
      "action": _vm.uploadImageApi,
      "with-credentials": true,
      "show-upload-list": false,
      "before-upload": _vm.uploadImageBefore
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-cloud-upload-outline"
    }
  })], 1), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticClass: "d-none upload-file",
    attrs: {
      "name": "upfile",
      "max-size": 10240,
      "headers": _vm.headers,
      "action": _vm.uploadFileApi,
      "with-credentials": true,
      "show-upload-list": false,
      "on-success": _vm.uploadFileSuccess,
      "before-upload": _vm.uploadFileBefore
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-cloud-upload-outline"
    }
  })], 1), _vm._v(" "), _c('quill-editor', {
    ref: "myQuillEditor",
    staticClass: "mt-3",
    attrs: {
      "id": "quillEditor",
      "options": _vm.editorOption
    },
    on: {
      "blur": function($event) {
        return _vm.onEditorBlur($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      },
      "ready": function($event) {
        return _vm.onEditorReady($event)
      },
      "change": function($event) {
        return _vm.onEditorChange($event)
      }
    },
    model: {
      value: (_vm.formValidate.postingContent),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "postingContent", $$v)
      },
      expression: "formValidate.postingContent"
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMarket.marketId == null),
      expression: "selectedMarket.marketId == null"
    }],
    staticClass: "mt-5 ml-0",
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowMarketListDialog = !_vm.isShowMarketListDialog
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.chooseTopic")))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMarket.marketId != null),
      expression: "selectedMarket.marketId != null"
    }],
    staticClass: "white--text mt-5 ml-0",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowMarketListDialog = !_vm.isShowMarketListDialog
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedMarket.name))]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isShowMarketListDialog),
      callback: function($$v) {
        _vm.isShowMarketListDialog = $$v
      },
      expression: "isShowMarketListDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pb-0",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("postingcreate.chooseTopic")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.isShowMarketListDialog = !_vm.isShowMarketListDialog
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.user.userName == 'iob_official' || _vm.user.userName == 'longnshort' || _vm.user.userName == 'Fred' || _vm.user.userName == 'louis' || _vm.user.userName == 'shirley' || _vm.user.userName == 'KateL' || _vm.user.userName == 'renlywen') ? _c('div', _vm._l((_vm.marketList), function(market) {
    return _c('v-btn', {
      key: market.marketId,
      staticClass: "white--text",
      attrs: {
        "depressed": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.selectMarket(market)
        }
      }
    }, [_vm._v(_vm._s(market.name))])
  }), 1) : _c('div', _vm._l((_vm.marketList), function(market) {
    return ('industrynews' == market.code) ? _c('v-btn', {
      key: market.marketId,
      staticClass: "white--text",
      attrs: {
        "depressed": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.selectMarket(market)
        }
      }
    }, [_vm._v(_vm._s(market.name))]) : _vm._e()
  }), 1)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.imageLinkDialog),
      callback: function($$v) {
        _vm.imageLinkDialog = $$v
      },
      expression: "imageLinkDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "placeholder": "Image Link",
      "outline": ""
    },
    model: {
      value: (_vm.imageLink),
      callback: function($$v) {
        _vm.imageLink = $$v
      },
      expression: "imageLink"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.insertImageLink.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.imageLinkDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "ShapeUser",
    attrs: {
      "max-width": "320px",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.atUserDialog),
      callback: function($$v) {
        _vm.atUserDialog = $$v
      },
      expression: "atUserDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.atUserDialog = !_vm.atUserDialog
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userFollowList.length == 0),
      expression: "userFollowList.length == 0"
    }],
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userFollowList.length != 0),
      expression: "userFollowList.length != 0"
    }],
    staticClass: "mt-5 mb-3"
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.userFollowList), function(userfollow, index) {
    return _c('div', {
      staticClass: "userFollow-li pointer mt-3 ml-5",
      on: {
        "click": function($event) {
          return _vm.userfollowing(userfollow)
        }
      }
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "40"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userfollow.image != null),
        expression: "userfollow.image != null"
      }],
      attrs: {
        "src": userfollow.image,
        "alt": userfollow.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userfollow.image == null),
        expression: "userfollow.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                    " + _vm._s(userfollow.userName != null ? userfollow.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])]), _vm._v(" "), _c('span', {
      attrs: {
        "id": "followUserName"
      }
    }, [_vm._v(_vm._s(userfollow.nickName))]), _vm._v(" \n                                    "), _c('span', {
      staticClass: "primary--text font-12 ml-2"
    }, [_vm._v("@" + _vm._s(userfollow.userName))])], 1)
  })], 2)])], 1)], 1)], 1), _vm._v(" "), _c('div', _vm._l((_vm.tagNameArray), function(tagName, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mt-3 ml-0",
      attrs: {
        "outline": "",
        "small": "",
        "color": "primary darken-1"
      }
    }, [_vm._v(_vm._s(tagName))])
  }), 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": _vm.$t('postingcreate.tagName'),
      "single-line": "",
      "outline": ""
    },
    on: {
      "input": _vm.tagchange
    },
    model: {
      value: (_vm.tagName),
      callback: function($$v) {
        _vm.tagName = $$v
      },
      expression: "tagName"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "10px",
      "display": "inline-block",
      "color": "red",
      "margin-top": "-15px",
      "margin-left": "10px"
    },
    attrs: {
      "id": "tagruleValidate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    class: _vm.formValidate.isOriginal ? 'primary' : '',
    attrs: {
      "small": "",
      "type": "ghost",
      "disabled": _vm.isDisabledOriginalBtn
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.formValidate.isOriginal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.original')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    class: _vm.formValidate.isOriginal ? '' : 'primary',
    attrs: {
      "small": "",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.formValidate.isOriginal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.repost')))]), _vm._v(" "), (_vm.formValidate.isOriginal) ? _c('div', [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "required": ""
    },
    model: {
      value: (_vm.isAgreeOriginalTerms),
      callback: function($$v) {
        _vm.isAgreeOriginalTerms = $$v
      },
      expression: "isAgreeOriginalTerms"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    on: {
      "click": function($event) {}
    },
    slot: "label"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("postingcreate.agree")) + "\n                      "), _c('span', {
    staticClass: "primary--text pointer"
  }, [_c('a', {
    attrs: {
      "href": "/#/about/ContentPolicy",
      "target": "_black"
    }
  }, [_vm._v("<<" + _vm._s(_vm.$t("postingcreate.contentPolicy")) + ">>")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.formValidate.isOriginal) ? _c('div', [_c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": _vm.$t('postingcreate.rules.originalLink.label'),
      "rules": _vm.originalLinkRules,
      "single-line": "",
      "outline": "",
      "required": ""
    },
    model: {
      value: (_vm.formValidate.originalLink),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "originalLink", $$v)
      },
      expression: "formValidate.originalLink"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "font-16 primary--text mt-3"
  }, [_vm._v(_vm._s(_vm.formValidate.postingId != null ? _vm.$t('postingcreate.message.updatePost') : ""))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isShowResetDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.Reset")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previewPostDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.preview.preview")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "type": "ghost",
      "loading": _vm.postLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.Post")))])], 1), _vm._v(" "), _c('div', [_c('v-dialog', {
    attrs: {
      "width": "40%",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isShowResetDialog),
      callback: function($$v) {
        _vm.isShowResetDialog = $$v
      },
      expression: "isShowResetDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.message.resetPost")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.isShowResetDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleReset.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isShowResetDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.previewPostDialog),
      callback: function($$v) {
        _vm.previewPostDialog = $$v
      },
      expression: "previewPostDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('postingcreate.preview.preview')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.previewPostDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": "",
      "lg10": ""
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingTitle != ''),
      expression: "formValidate.postingTitle != ''"
    }],
    staticClass: "fw-bold mb-3 display-1"
  }, [_vm._v(_vm._s(_vm.formValidate.postingTitle))]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingTitle == ''),
      expression: "formValidate.postingTitle == ''"
    }],
    staticClass: "fw-bold mb-3 display-1"
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.preview.hint.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled mb-5"
  }, [_c('li', {
    staticClass: "userDetail"
  }, [_c('div', {
    staticClass: "imgleft"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "40"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user != null && _vm.user.image != null),
      expression: "user != null && user.image != null"
    }],
    attrs: {
      "src": _vm.user.image,
      "alt": _vm.user.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user == null || _vm.user.image == null),
      expression: "user == null || user.image == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v(_vm._s(_vm.user.userName != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side ml-2"
  }, [_c('span', {
    staticClass: "title-1 font-md pointer primary--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.user.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(_vm.user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 font-md"
  }, [_vm._v(_vm._s(_vm.$t("common.at")) + " " + _vm._s(_vm.dateFormat(+new Date())))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingContent != ''),
      expression: "formValidate.postingContent != ''"
    }],
    staticClass: "mb-5 font-18 fw-400 ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.formValidate.postingContent)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingContent == ''),
      expression: "formValidate.postingContent == ''"
    }],
    staticClass: "mb-5 font-18 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.preview.hint.content')))]), _vm._v(" "), _c('div', _vm._l((_vm.tagNameArray), function(tagName, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "outline": "",
        "small": "",
        "color": "primary darken-1"
      }
    }, [_vm._v(_vm._s(tagName))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "userDetail mt-4"
  }, [_c('span', {
    staticClass: "font-md fw-semi-bold"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("timer")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(+new Date())) + " " + _vm._s(_vm.$t("common.by")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgleft ml-3"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.image != null),
      expression: "user.image != null"
    }],
    attrs: {
      "src": _vm.user.image,
      "alt": _vm.user.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.image == null),
      expression: "user.image == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v(_vm._s(_vm.user.userName != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side ml-2 primary--text"
  }, [_c('span', {
    staticClass: "Author"
  }, [_c('span', {
    staticClass: "font-md fw-semi-bold"
  }, [_vm._v("\n                            " + _vm._s(_vm.user.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(_vm.user.reputationScore) + ")")])])])])]), _vm._v(" "), _c('div', {}, [(_vm.formValidate.isOriginal) ? _c('span', {
    staticClass: "primary--text ml-2 font-14 fw-700"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.original')))]) : _vm._e(), _vm._v(" "), (!_vm.formValidate.isOriginal) ? _c('span', {
    staticClass: "pointer primary--text ml-2 font-14 fw-700"
  }, [_c('a', {
    attrs: {
      "href": _vm.formValidate.originalLink,
      "target": "_black"
    }
  }, [_vm._v(_vm._s(_vm.$t('postingsel.source')))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "social-list clearfix right"
  }, [_c('ul', {
    staticClass: "list-inline d-inline-block right"
  }, [_c('li', [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.bonus')
    }
  }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', [_vm._v("0.00")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('postingsel.tread')
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.comment')
    }
  }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.retweet')
    }
  }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.save')
    }
  }, [_vm._v("fa fa-star")])], 1)])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "right",
    attrs: {
      "color": "primary",
      "loading": _vm.postLoading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate', _vm.file)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.Post")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "right",
    attrs: {
      "color": "primary",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previewPostDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.close")))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01212839"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/CreatePost.vue
// module id = 410
// module chunks = 0